
<script>
import Vue from 'vue';

Vue.prototype.$ckValidator = {};

Vue.prototype.$ckValidator.required = function (val, ckItem, ckForm) {
    const isRequired = true;
    if (Array.isArray(val)) {
        if (val.length !== 0) {
            let valid = true;
            for (let i = 0, l = val.length; i < l; i++) {
                valid = required(val[i], isRequired);
                if ((isRequired && !valid) || (!isRequired && valid)) {
                    break;
                }
            }
            return valid;
        } else {
            return !isRequired;
        }
    } else if (typeof val === 'number' || typeof val === 'function') {
        return isRequired;
    } else if (typeof val === 'boolean') {
        // return val === isRequired;
        return true;
    } else if (typeof val === 'string') {
        return isRequired ? (val.length > 0) : (val.length <= 0);
    } else if (val !== null && typeof val === 'object') {
        return isRequired ? (Object.keys(val).length > 0) : (Object.keys(val).length <= 0);
    } else if (val === null || val === undefined) {
        return !isRequired;
    } else {
        return !isRequired;
    }
}

var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
Vue.prototype.$ckValidator.email = function (val, ckItem, ckForm) {
    return re.test(val);
}
</script>


// WEBPACK FOOTER //
// src/components/ck-form/ck-validators.vue